export const log = require("debug")(
  "plugin:gatsby-plugin-i18n",
)
